import { render, staticRenderFns } from "./Chessboard.vue?vue&type=template&id=1e72ceb7&scoped=true"
import script from "./Chessboard.vue?vue&type=script&lang=js"
export * from "./Chessboard.vue?vue&type=script&lang=js"
import style0 from "./Chessboard.vue?vue&type=style&index=0&id=1e72ceb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e72ceb7",
  null
  
)

export default component.exports